module.exports = __webpack_public_path__ + "img/image006.f5375451.jpg";